import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Carousel from './Carousel';
import '../../../Styles/modalPortfolio.css'


const ModalPortfolio = ({title, img1, img2, img3, desc, link1, link2}) => {

    const [lgShow, setLgShow] = useState(false);

    return (
        <>
            <Button className="btn" onClick={() => setLgShow(true)}>View system</Button>
            
            <Modal
                size="lg"
                show={lgShow}
                onHide={() => setLgShow(false)}
                aria-labelledby="example-modal-sizes-title-lg" 
                
            >
                <Modal.Header closeButton closeVariant='black' className="o-modal" >
                    <Modal.Title id="example-modal-sizes-title-lg">
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="o-modal">
                    <Carousel img1={img1} img2={img2} img3={img3}></Carousel>
                    <p className="o-desc-mod">{desc}</p>
                    <div className="row o-icon-modal">
                    <a target="_blank" rel="noreferrer" href={link1} className="o-icon-mod"><i class="fas fa-link"></i></a>
                    <a target="_blank" rel="noreferrer" href={link2} className="o-icon-mod"><i class="fab fa-github"></i></a>
                    
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );

};
export default ModalPortfolio;